module.exports = __webpack_public_path__ + "static/img/pt.23adb9fe.svg";